import { ColumnConfig } from '@/components/table/Table';
import { Badge } from '@/components';
import { Transition, TransitionType, TransitionTypeLabels } from '../models';

const typeColors: Record<
  TransitionType,
  { backgroundColor: string; ballColor: string; textColor: string }
> = {
  [TransitionType.SINGLE]: {
    backgroundColor: '#E3F2FD',
    ballColor: '#1976D2',
    textColor: '#1976D2',
  },
  [TransitionType.BATCH]: {
    backgroundColor: '#F3E5F5',
    ballColor: '#7B1FA2',
    textColor: '#7B1FA2',
  },
};

export const transitionsTableColumns: ColumnConfig[] = [
  {
    label: 'Nombre',
    field: 'name',
  },
  {
    label: 'Tipo',
    field: 'type',
    render: (value: TransitionType) => {
      const colors = typeColors[value] || typeColors[TransitionType.SINGLE];
      const label = TransitionTypeLabels[value] || value;
      return <Badge value={label} {...colors} />;
    },
  },
  {
    label: 'Incluir Todos',
    field: 'includeAll',
    render: (value: boolean) => (value ? 'Sí' : 'No'),
  },
  {
    label: 'Estados Excluidos',
    field: 'excludedCount',
    render: (value: number) => value.toString(),
  },
  {
    label: 'Estados Incluidos',
    field: 'includedCount',
    render: (value: number) => value.toString(),
  },
];
